const Settings = { service: 'settings', model: 'Pin' };

export default {
  state: {
    pin: {},
    pins: [],
  },
  getters: {
    pin: state => state.pin,
    pins: state => state.pins,
  },
  actions: {
    getPin({ dispatch, commit }, pin) {
      return dispatch('Acacia/Utils/Resources/GET', {
        ...Settings,
        url: `/${pin}`,
      })
        .then(response => commit('SET_PIN', response));
    },
    getPins({ dispatch, commit }) {
      return dispatch('Acacia/Utils/Resources/GET', { ...Settings })
        .then(response => commit('SET_PINS', response));
    },
    createPin({ dispatch, commit }, data) {
      return dispatch('Acacia/Utils/Resources/POST', { ...Settings, data })
        .then(response => commit('ADD_PIN', response));
    },
    updatePin({ dispatch, commit }, data) {
      return dispatch('Acacia/Utils/Resources/PATCH', {
        ...Settings,
        url: `/${data.pin}`,
        data,
      })
        .then(response => commit('UPDATE_PIN', response));
    },
    deletePin({ dispatch, commit }, pin) {
      return dispatch('Acacia/Utils/Resources/DELETE', {
        ...Settings,
        url: `/${pin}`,
      })
        .then(() => commit('DELETE_PIN', pin));
    },
  },
  mutations: {
    SET_PIN(state, payload) {
      state.pin = payload;
    },
    SET_PINS(state, payload) {
      state.pins = payload;
    },
    ADD_PIN(state, payload) {
      state.pins.push(payload);
    },
    UPDATE_PIN(state, payload) {
      state.pins[state.pins.findIndex(item => item.pin === payload.pin)] = payload;
    },
    DELETE_PIN(state, pin) {
      state.pins = state.pins.filter(item => item.pin !== pin);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/settings.js